import Button from 'antd/lib/button'
import { useEffect, useRef, useState } from 'react'
import styles from './Attributes.module.less'

type AttributesDescriptionPropsType = {
    description?: string
}

export const AttributeDescription = (props: AttributesDescriptionPropsType) => {
    const [isDescriptionExpanded, setIsDescriptionExpanded] = useState<boolean>(false)
    const [isDescriptionOverflowing, setIsDescriptionOverflowing] = useState(false)
    const textRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        /*
         * The side panels rendering and the antd forms are causing an issue with rendering the component.
         * Even after the component has mounted, there's no guarantee that the side panels have been rendered
         * properly so we use resize observer to handle it. When we find the scroll height and the client height,
         * it means that the component has properly rendered so we remove the resize observer.
         */
        const observer = new ResizeObserver(entries => {
            for (const entry of entries) {
                const { scrollHeight, clientHeight } = entry.target
                setIsDescriptionOverflowing(scrollHeight > clientHeight)

                if (scrollHeight > 0 && clientHeight > 0) {
                    observer.disconnect()
                }
            }
        })

        if (textRef.current) {
            observer.observe(textRef.current)
        }

        return () => {
            observer.disconnect()
        }
    }, [])

    return (
        <>
            <div
                ref={textRef}
                className={
                    styles['description-container'] +
                    ' ' +
                    (isDescriptionExpanded ? styles['expanded'] : styles['collapsed'])
                }
            >
                {props.description}
            </div>
            {isDescriptionOverflowing && (
                <Button
                    onClick={() => setIsDescriptionExpanded(!isDescriptionExpanded)}
                    className={styles['expand-button']}
                >
                    {isDescriptionExpanded ? 'Show Less' : 'Show More'}
                </Button>
            )}
        </>
    )
}
